import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'

export const deleteArtifact = async (publicId: string): Promise<void> => {
  await forgeApi.delete(`/api/v1/artifacts/${encodeURIComponent(publicId)}`)
}

export const useDeleteArtifactMutation = (
  options?: ExtendableMutationOptions<void, string>
) =>
  useMutation({
    mutationFn: deleteArtifact,
    ...options
  })
